import { render } from "./MiTooltip.vue?vue&type=template&id=3a5c18a1"
import script from "./MiTooltip.vue?vue&type=script&lang=js"
export * from "./MiTooltip.vue?vue&type=script&lang=js"

import "./MiTooltip.vue?vue&type=style&index=0&id=3a5c18a1&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
